import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function cr1(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@cr1/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@cr1/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@cr1/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@cr1/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@cr1/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@cr1/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}